import React from 'react';
import { cn } from '@/utils';
import { FolderFilledIcon } from '@/components/Icons';

interface FolderInputProps {
  onEnter: (val: string) => void;
  onClose: () => void;
  placeholder?: string;
}

export const FolderInput: React.FC<FolderInputProps> = ({
  onEnter,
  onClose,
  placeholder = 'New Catalog Folder ',
}) => {
  return (
    <div className=" relative">
      <input
        prefix="123"
        autoFocus
        maxLength={30}
        placeholder={placeholder}
        className={cn(
          ' w-full box-border border-jen-interactive-primary pl-[34px] flex-shrink-0  h-[32px] border active:border-jen-blue  rounded text-jen-interactive-primary text-[16px] outline-none',
        )}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Enter') {
            if ((e.target as HTMLInputElement).value?.trim()) {
              onEnter((e.target as HTMLInputElement).value);
            } else {
              onClose();
            }
          }
          if (e.key === 'Escape') {
            onClose();
          }
        }}
        onBlur={(e) => {
          const val = e.target.value?.trim();
          if (!val) {
            onClose();
          } else {
            onEnter(val);
          }
        }}
      ></input>
      <FolderFilledIcon className=" absolute top-[4px] left-[3px]" />
    </div>
  );
};
